import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../_shared/shared.module';
import { BankAccountEditorComponent } from './payment/bank-account/bank-account-editor/bank-account-editor.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { GeneralUserEditorComponent } from './user-editor/general-user-editor/general-user-editor.component';
import { UserEditorComponent } from './user-editor/user-editor.component';
import { UserSignatureComponent } from './user-editor/user-signature/user-signature.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserRoutingModule } from './user-routing.module';
import { UserSettingsComponent } from './user-settings/user-settings.component';

@NgModule({
  imports: [
    SharedModule,
    UserRoutingModule,
    AngularSignaturePadModule
  ],
  declarations: [
    UserListComponent,
    UserDetailComponent,
    UserEditorComponent,
    UserSettingsComponent,
    BankAccountEditorComponent,
    GeneralUserEditorComponent,
    UserSignatureComponent
  ],
  exports:      [
    BankAccountEditorComponent,
  ],
})
export class UserModule {
}
